export const sliderItems = [
    {
        id: 1,
        title: "SUMMER SALE",
        img: "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/16988744/2022/2/23/f4c963e6-dd44-439b-80f2-e10e1b608adb1645558630984KALINIWomenBluePrintedDress1.jpg",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS",
        bg: "F2F2F2"
    },

    {
        id: 2,
        title: "AUTUMN COLLECTION",
        img: "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/7256771/2018/8/31/cdb233ae-f808-48a8-890f-d40ec0ffb0c71535699793315-NA-6081535699793230-5.jpg",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS",
        bg: "FFFFFF"
    },

    {
        id: 3,
        title: "LOUNGEWEAR LOVE",
        img: "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/17132170/2022/2/11/c29a70dd-b429-434a-913c-5bc4b103fa561644564800519VishudhPeach-ColouredEthnicMotifsEthnicMaxiDress1.jpg",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS",
        bg: "F3F6F8"
    },
];

export const categories = [
    {
        id: 1,
        img: "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/productimage/2021/1/27/95803658-de92-4e63-932e-86ed041116441611743614531-1.jpg",
        title: "SHIRT STYLE!",
        cat:"women",
    },
    {
        id: 2,
        img: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/7411324/2018/9/15/fc29403d-1d48-4fdc-b81d-89160ab96b7f1537002876305-na-6121537002876170-3.jpg",
        title: "LOUNGEWEAR LOVE",
        cat:"coat",
    },
    {
        id: 3,
        img: "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/17685324/2022/3/30/80c69a68-1f9b-4d26-9ff6-07cc4fbc20be1648630430350BUYNEWTRENDWomenBlueStripedLightweightDenimJacketwithEmbroid1.jpg",
        title: "LIGHT JACKETS",
        cat:"jeans",
    }
];

export const popularProducts = [
    {
        id:1,
        img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
      },
      {
        id:2,
        img:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/7240789/2018/8/29/08ece6e4-9d6b-48e1-b49a-6d212c49cf001535523371025-NA-6191535523370910-1.jpg",
      },
      {
        id:3,
        img:"https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
      },
      {
        id:4,
        img:"https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
      },
      {
        id:5,
        img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
      },
      {
        id:6,
        img:"https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
      },
      {
        id:7,
        img:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/16065180/2021/11/11/e46441c7-467f-48b1-95e4-2496e02a9b341636632357159CherokeeGirlsBlueQuiltedJacket1.jpg",
      },
      {
        id:8,
        img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
      },
];